import z from 'zod';
export const invoiceTypeValue = z.enum([
    'subscription',
    'lawyer-consultation',
    'additional-product',
]);
export const createInvoiceType = (value) => invoiceTypeValue.parse(value);
//# sourceMappingURL=invoice-type.js.map